import { render, staticRenderFns } from "./ScheduleAgenda.vue?vue&type=template&id=1c8c913f"
import script from "./ScheduleAgenda.vue?vue&type=script&lang=js"
export * from "./ScheduleAgenda.vue?vue&type=script&lang=js"
import style0 from "./ScheduleAgenda.vue?vue&type=style&index=0&id=1c8c913f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports